import { makeStyles } from '@rbx/ui';

const useNotificationStyles = makeStyles()(theme => ({
  cardRadius: {
    borderRadius: 8
  },

  container: {
    backgroundColor: theme.palette.surface[400],
    padding: 6,
    paddingRight: 12,
    flexWrap: 'nowrap'
  },

  readIconContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 5
  },

  readIcon: {
    borderRadius: '100%'
  },

  notificationText: {
    paddingLeft: 6,
    paddingRight: 6,
    overflow: 'hidden'
  },

  truncatedText: {
    overflow: 'hidden',
    lineClamp: 2,
    boxOrient: 'vertical',
    display: '-webkit-box'
  },

  disabledDot: {
    backgroundColor: theme.palette.states.disabled
  },

  thumbnailContainer: {
    width: 24,
    height: 24
  }
}));

export default useNotificationStyles;
